/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorSlider from 'base/components/labrador/Slider';

export const DynamicLabradorSlider: typeof LabradorSlider = (props) => {
    return <ErrorBoundary><LabradorSlider {...props} /></ErrorBoundary>;
}
export type DynamicLabradorSliderProps = PropsFromComponent<typeof LabradorSlider>;
